import * as React from 'react';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import ErrorsCore from '../AfrCore/ErrorsCore';
import UserRoleEnum from '../../redux/UserSlice';

const CR29Errors = (props: any) => {

    return (
        <React.Fragment>
            <ErrorsCore userRole={UserRoleEnum.EntityUser} taxType={TaxonomyTypeEnum.COURT_REPORTING_29} reportName="Court Report 29.0085"  />
        </React.Fragment>
    );
}

export default CR29Errors;